export class CustomerResult {
    public id: number = 1;
    public code: string = '';
    public name: string = '';
    public taxNumber: string = '';
    public logoFileName = '';
    public taxAdministration: string = '';
    public isDeleted: boolean = false;
}
